import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { TagFilter } from "./TagFilter";

var map = require("lodash/map");

export var TagFilterList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TagFilterList, _React$Component);

  function TagFilterList() {
    _classCallCheck(this, TagFilterList);

    return _possibleConstructorReturn(this, _getPrototypeOf(TagFilterList).apply(this, arguments));
  }

  _createClass(TagFilterList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          field = _this$props.field,
          values = _this$props.values,
          searchkit = _this$props.searchkit;
      return React.createElement("div", {
        className: "sk-tag-filter-list"
      }, map(values, function (value) {
        return React.createElement(TagFilter, {
          key: value,
          field: field,
          value: value,
          searchkit: searchkit
        });
      }));
    }
  }]);

  return TagFilterList;
}(React.Component);